import { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";

// Automatic logoff after inactivity (HIPAA Security Rule §164.312(a)(2)(iii)).
// Staff sessions use a shorter idle window than patients.
const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click"];

export function useIdleLogout({ minutes = 15, onIdle } = {}) {
  const { logout } = useAuth();
  const timer = useRef(null);

  useEffect(() => {
    const ms = minutes * 60 * 1000;
    const reset = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(async () => {
        await logout();
        if (onIdle) onIdle();
      }, ms);
    };
    ACTIVITY_EVENTS.forEach((ev) => window.addEventListener(ev, reset, { passive: true }));
    reset();
    return () => {
      if (timer.current) clearTimeout(timer.current);
      ACTIVITY_EVENTS.forEach((ev) => window.removeEventListener(ev, reset));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minutes]);
}
